import { createAction } from "@reduxjs/toolkit";

export const toggleUtilityModalVisibility = createAction("TOGGLE_UTILITY_MODAL")
export const customerChangeSelectedTab = createAction("CHANGE_SELECTED_TAB")
export const prevBillsPage = createAction("PREV_BILLS_PAGE")
export const nextBillsPage = createAction("NEXT_BILLS_PAGE")
export const resetCustomerTab = createAction("RESET_CUSTOMER_TAB")